function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
import { ContextActionUtils } from '@deephaven/components';
import { GridMouseHandler } from '@deephaven/grid';
/**
 * Used to handle sorting on column header clicks
 */
class IrisGridSortMouseHandler extends GridMouseHandler {
  constructor(irisGrid) {
    super();
    _defineProperty(this, "irisGrid", void 0);
    _defineProperty(this, "column", void 0);
    this.column = null;
    this.irisGrid = irisGrid;
  }
  getColumnFromGridPoint(gridPoint) {
    var column = gridPoint.column,
      row = gridPoint.row,
      columnHeaderDepth = gridPoint.columnHeaderDepth;
    if (column !== null && row === null && columnHeaderDepth === 0) {
      return column;
    }
    return null;
  }

  // We need to remember where the down started, because the canvas element will trigger a click whereever mouseUp is
  onDown(gridPoint) {
    this.column = this.getColumnFromGridPoint(gridPoint);
    return false;
  }
  onClick(gridPoint, grid, event) {
    var column = this.getColumnFromGridPoint(gridPoint);
    if (column != null && column === this.column) {
      var addToExisting = ContextActionUtils.isModifierKeyDown(event);
      this.irisGrid.toggleSort(column, addToExisting);
      return true;
    }
    return false;
  }
}
export default IrisGridSortMouseHandler;
//# sourceMappingURL=IrisGridSortMouseHandler.js.map